<template>
    <hh-btn class="nav-destination" :icon-class="iconClass" :text="text" :type="type" @click="handleClick" />
</template>

<script>

export default {

    props: {

        to: {
            type: Object,
            default: null,
        },
        iconClass: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
    },

    methods: {
        handleClick() {
            if (this.to)
                this.$router.push(this.to)
            else
                this.$emit('click')
        },
    },
}
</script>

<style lang="scss">

.nav-destination {
    padding: 0.2rem 0.6rem !important;
    margin-top: 0 !important;

    .button__icon--pre {
        padding-right: 0;

        @include bp-min-small {
            padding-right: 0.4em;
        }
    }

    .button__text {
        display: none;

        @include bp-min-small {
            display: inline;
        }
    }
}

</style>
